import { createIcon } from './create-icon';

export const TrophyIcon = createIcon(
  'TrophyIcon',
  <>
    <path d="M8 21h8M12 17v4" />
    <path d="M5 3h14v8a7 7 0 01-14 0V3z" />
    <path d="M5 7H2a2 2 0 002 2h1M19 7h3a2 2 0 01-2 2h-1" />
  </>,
);
